export const EVENTS = {
  AUTHORIZE: "extensorAuthorize",
  AUTH_RESULT: "extensorAuthResult",
  AUTH_TIMEOUT: "authTimeout"
};
